export const USER_LOGIN = 'redux/auth/USER_LOGIN';
export const USER_LOGOUT = 'redux/auth/USER_LOGOUT';